import React from 'react';
import { UseFormReturn } from 'react-hook-form';

import { UiTypography } from '@/components/ui/Typography';
import { ApiUserCategoryType } from '@/modules/api';

import { CATEGORIES_SETUP } from '../../constants';
import { OnboardingParamsTool } from '../../utils/paramsTool';

import {
  PreferencesListV2ItemStyles,
  PreferencesListV2Styles,
} from './V2.styles';

export const PreferencesListV2: React.FC<{
  preloadCategories: ApiUserCategoryType[];
  categories: string[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: UseFormReturn<any>;
}> = ({ preloadCategories, categories, form }) => {
  return (
    <PreferencesListV2Styles>
      {preloadCategories &&
        preloadCategories.map((option) => {
          const selected = categories?.includes(option.id);
          const aiNumber =
            option.id in CATEGORIES_SETUP
              ? CATEGORIES_SETUP[option.id].number
              : 849;

          return (
            <PreferencesListV2ItemStyles
              key={option.id}
              imageSrc={option.background_picture?.v2 || ''}
              selected={selected}
              onClick={() => {
                const fieldValues = form.getValues('categories');

                const hasFormValue = fieldValues.includes(option.id);

                const copiedCategories = [...categories];

                if (hasFormValue) {
                  form.setValue(
                    'categories',
                    fieldValues.filter((x: string) => x !== option.id),
                  );
                  copiedCategories.splice(
                    copiedCategories.indexOf(option.id),
                    1,
                  );
                } else {
                  form.setValue('categories', [...fieldValues, option.id]);
                  copiedCategories.push(option.id);
                }

                OnboardingParamsTool.setParam('categories', copiedCategories);
              }}
            >
              <UiTypography variant="body-large" className="item-title">
                {option.title}
              </UiTypography>
              <UiTypography color="neutral-black" variant="body-medium">
                {aiNumber} AIs
              </UiTypography>
            </PreferencesListV2ItemStyles>
          );
        })}
    </PreferencesListV2Styles>
  );
};
